<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <h3 class="page-header">Reporting for</h3>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12 col-xs-6 col-sm-3" *ngIf="(permissions.canRead(permissions.ComponentID.Reporting))">
      <div row>
        <div class="col-xs-12">
          <b><u>All Active and EOA employee's</u></b>
        </div>
      </div>

      <div row>
        <div class="col-xs-12 printButton">
           <aims-common-button
            (click)="printOfficePhoneListing()">
            <mat-icon color="primary">print</mat-icon>
            Office Phone Listing
          </aims-common-button>
        </div>
      </div>

      <div row *ngIf="tenantUsesPsc">
        <div class="col-xs-12 printButton">
           <aims-common-button
            (click)="printSeniorityList()">
            <mat-icon color="primary">print</mat-icon>
            Seniority List
          </aims-common-button>
        </div>
      </div>

      <div row *ngIf="tenantUsesPsc">
        <div class="col-xs-12 printButton">
           <aims-common-button
            (click)="printActiveAndEOASpecialtyList()">
            <mat-icon color="primary">print</mat-icon>
            Specialty List
          </aims-common-button>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-xs-6 col-sm-3" *ngIf="(permissions.canRead(permissions.ComponentID.PscHrRoutingQueue) ||
          permissions.canRead(permissions.ComponentID.PscHrmApprovalQueue) ||
          permissions.canRead(permissions.ComponentID.PscPmmApprovalQueue) ||
          permissions.canRead(permissions.ComponentID.PscAcctReceivalQueue))">
      <div row>
        <div class="col-xs-12">
          <b><u>HR/PM/Acct - Only</u></b>
        </div>
      </div>
      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button
            (click)="printActiveAndEOAEmpCounts()">
            <mat-icon color="primary">print</mat-icon>
            Emp Counts
          </aims-common-button>
        </div>
      </div>

      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button
            (click)="printActiveAndEOAEmpList()">
            <mat-icon color="primary">print</mat-icon>
            Emp List
          </aims-common-button>
        </div>
      </div>

      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button
            (click)="printEmpStatusChange()">
            <mat-icon color="primary">print</mat-icon>
            Employee Status Change
          </aims-common-button>
        </div>
      </div>
      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button
            (click)="printYearsOfService()">
            <mat-icon color="primary">print</mat-icon>
            Years Of Service
          </aims-common-button>
        </div>
      </div>
      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button
            (click)="printEmployeeAgeStatistics()">
            <mat-icon color="primary">print</mat-icon>
            Employee Age Statistics
          </aims-common-button>
        </div>
      </div>
      <div class="col-xs-12 col-xs-6 col-sm-3">
      </div>


    </div>
    <div class="col-xs-12 col-xs-6 col-sm-3" *ngIf="(permissions.canRead(permissions.ComponentID.PscHrRoutingQueue) ||
          permissions.canRead(permissions.ComponentID.PscHrmApprovalQueue))">
      <div row>
        <div class="col-xs-12">
          <b><u>HR - Only</u></b>
        </div>
      </div>

      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button
            (click)="printEmpAddressesAndContact()">
            <mat-icon color="primary">print</mat-icon>
            Employee Addresses/Contact
          </aims-common-button>
        </div>
      </div>

      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button
            (click)="printCACStatus()">
            <mat-icon color="primary">print</mat-icon>
            CAC Status
          </aims-common-button>
        </div>
      </div>

      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button
            (click)="printClearanceStatus()">
            <mat-icon color="primary">print</mat-icon>
            Clearance Status
          </aims-common-button>
        </div>
      </div>

      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button
            (click)="printDLStatus()">
            <mat-icon color="primary">print</mat-icon>
            Driver's License Status
          </aims-common-button>
        </div>
      </div>

      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button
            (click)="printActiveAndEOAShareholderList()">
            <mat-icon color="primary">print</mat-icon>
            Shareholder List
          </aims-common-button>
        </div>
      </div>

      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button
            (click)="printActiveAndEOAVeteranList()">
            <mat-icon color="primary">print</mat-icon>
            Veteran List
          </aims-common-button>
        </div>
      </div>

      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button
            (click)="printProbationReport()">
            <mat-icon color="primary">print</mat-icon>
            Probation Days Worked
          </aims-common-button>
        </div>
      </div>

      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button
            (click)="printEmpHours()">
            <mat-icon color="primary">print</mat-icon>
            Employee Hours
          </aims-common-button>
        </div>
      </div>

    </div>
  </div>
</div>


